import { Button } from '@mui/material';
import { Modal, useModalState } from 'greener-ui-library';
import { ButtonWithConfirmationDialogProps } from '../buttons.types';

export function ButtonWithConfirmationDialog({
  handleConfirm,
  buttonText,
  confirmButtonText,
  cancelButtonText,
  variant = 'text',
  ButtonComponent = Button,
  children,
  buttonProps = {},
  dialogProps = {},
  title = '',
  color = 'primary',
  onClose = async () => {},
  dialogConfirmButtonProps = {},
  startIcon,
}: ButtonWithConfirmationDialogProps) {
  const { isModalOpen, openModal, closeModal } = useModalState();

  const handleClose = async () => {
    await onClose();
    closeModal();
  };

  return (
    <>
      <ButtonComponent
        data-testid="button-with-confirmation-dialog"
        variant={variant}
        color={color}
        onClick={openModal}
        startIcon={startIcon}
        {...buttonProps}
      >
        {buttonText}
      </ButtonComponent>
      <Modal
        title={title}
        isOpen={isModalOpen}
        onClose={handleClose}
        onCancel={handleClose}
        onPrimaryButtonClick={() => {
          handleConfirm();
          closeModal();
        }}
        primaryButtonTitle={confirmButtonText}
        primaryButtonProps={dialogConfirmButtonProps}
        cancelButtonTitle={cancelButtonText}
        data-testid="confirmation-dialog"
        dialogProps={dialogProps}
      >
        {children}
      </Modal>
    </>
  );
}
